import React from 'react';
import './sabhasad-karj.css';

const SabhasadKarj = () => {
  return (
    <div className="sabhasad-karj-container">

      <div className="banner">
      <img src="/images/slider1.jpg" alt="Banner" className="banner" />
    </div>

      <h1>सभासद कर्ज</h1>
      <p>
        या व्यवहारी जगात लहानसहान आर्थिक अडचणींमुळे मोठे नुकसान सोसावं लागत. अनेकदा आपल्याला काही वैयक्तिक कारणास्तव 
        अल्पावधी साठी पैशांची गरज असते मात्र वेळीच पैसे न मिळाल्याने मोठे नुकसान सोसावे लागते. पण आता नाही! तुमची हीच 
        गरज लक्षात घेऊन <strong>श्री वरद विनायक पतसंस्था </strong> तुम्हाला उपलब्ध करून देते अल्प व दीर्घकाळासाठी <strong>सभासद कर्ज</strong>. 
        ते सुद्धा कमीत कमी कागदपत्रे व तत्काळ मंजूर करून दिले जाते ज्यामुळे वेळीच तुमची गरज पूर्ण होते.
      </p>

    
      <h1>आवश्यक कागदपत्रे:</h1>
      <ul>
        <li>आधार कार्ड झेरॉक्स</li>
        <li>पॅन कार्ड झेरॉक्स</li>
        <li>100 रुपये चे दोन स्टॅम्प पेपर</li>
        <li>बँक पासबुक (कर्जदाराचे)</li>
        <li>इतर संस्थेची (NOC)</li>
        <li>पोस्टाचे 4 तिकीट</li>
        <li>3 चेक</li>
        <li>2 फोटो</li>
        <li>दोन जामीनदार व त्यांचे आधार कार्ड (झेरॉक्स)</li>
      </ul>
    </div>
  );
};

export default SabhasadKarj;
